import { useState, useEffect } from 'react';

export const useBrowser = () => {
  const [browser, setBrowser] = useState(false);
  useEffect(() => setBrowser(true), []);
  return browser;
};
